import React, { type ComponentPropsWithoutRef } from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { BannerAnnouncement as BannerAnnouncementType } from './BannerV2BannerAnnouncement.tsx';
import type { BannerV2BannerAnnouncement$key } from './__generated__/BannerV2BannerAnnouncement.graphql.ts';

const BannerAnnouncement: LazyComponent<
	({
		jiraQueryFragment,
	}: {
		jiraQueryFragment?: BannerV2BannerAnnouncement$key | null;
	}) => React.JSX.Element | null
> = lazyAfterPaint<typeof BannerAnnouncementType>(
	() =>
		import(
			/* webpackChunkName: "async-platform-ui-banners-announcement-v2" */ './BannerV2BannerAnnouncement.tsx'
		).then((module) => module.BannerAnnouncement),
	// eslint-disable-next-line jira/entry-fs/restrict-shell-only-to-navigation-apps
	{ ssr: true, entryFsSsrLiftImportToModule: true, includeInShellOnlySsrBundle: true },
);

export const BannerAnnouncementAsync = (
	props: ComponentPropsWithoutRef<typeof BannerAnnouncement>,
): React.JSX.Element => (
	<Placeholder name="async-platform-ui-banners-announcement" fallback={null}>
		<BannerAnnouncement {...props} />
	</Placeholder>
);
